import { createRouter, createWebHistory } from 'vue-router';
import BoxHome from './views/BoxHome.vue';
import PromptManager from './views/PromptManager.vue';
import CreateAgent from './views/CreateAgent.vue';
import CreatePrompt from './views/CreatePrompt.vue';
import ChatBI from './views/ChatBI.vue';
import CheckTable from './views/CheckTable.vue';
import UserLogin from './views/UserLogin.vue';
import DeepReader from './views/DeepReader.vue';
import HumanResource from './views/HumanResource.vue';
import AnswerQuestion from './views/AnswerQuestion.vue';
import DataManager from './views/DataManager.vue';



const routes = [
    {
        path: '/beyond',
        redirect: '/'
    },
    {
        path: '/',
        name: 'BoxHome',
        component: BoxHome
    },
    {
        path: '/prompts',
        name: 'PromptManager',
        component: PromptManager
    },
    {
        path: '/agents',
        name: 'CreateAgent',
        component: CreateAgent
    },
    {
        path: '/prompt',
        name: 'CreatePrompt',
        component: CreatePrompt
    },
    {
        path: '/chat2bi',
        name: 'ChatBI',
        component: ChatBI
    },
    {
        path: '/checktable',
        name: 'CheckTable',
        component: CheckTable
    },
    {
        path: '/login',
        name: 'UserLogin',
        component: UserLogin
    },
    {
        path: '/read',
        name: 'DeepReader',
        component: DeepReader
    },
    {
        path: '/human',
        name: 'HumanResource',
        component: HumanResource
    },
    {
        path: '/test',
        name: 'AnswerQuestion',
        component: AnswerQuestion
    },
    {
        path: '/data',
        name: 'DataManager',
        component: DataManager
    }
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes // short for `routes: routes`
});

export default router;